/**
 * *
 * RRA_PC_01
 */
import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as $ from 'jquery';
import * as MenuAction from './MenuAction';
/*
 * RRA_PC_02
 * */
const RRPageLoadAction = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReceivingReport,
            SDIConstants.methodNames.ReceivingReport_PageLoad,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    //;
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.ReceivingReport_PageLoad, response: data.response };
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        //;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
/**
 * RRA_PC_03
 * */
const GoButtonClickAction = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReceivingReport,
            SDIConstants.methodNames.ReceivingReport_GoButtonClick,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    //;
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.ReceivingReport_GoButtonClick, response: data.response };
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        //;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const insertFavPage = async (insertFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_InsertFavPage,
            JSON.stringify(insertFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ORDERSTS_InsertFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const deleteFavPage = async (deleteFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_DeleteFavPage,
            JSON.stringify(deleteFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ORDERSTS_DeleteFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
//WBW - 11 Receiving Report - Excel Change - Deepthi N H
const ExportData = (excelbo) => {
    try {
        ;
        SDISVC.downloadFile(
            SDIConstants.moduleNames.ReceivingReport,
            SDIConstants.methodNames.ReceivingReportExportExcel,
            JSON.stringify(excelbo),
            "ReceivingReport.xlsx",
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        ;
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        let contentData = { type: "Export", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const getCurrentFavPage = async (getFavPageBO) => {
    try {
        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCurrentFavPage,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ORDERSTS_CurrentFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
export {
    RRPageLoadAction, GoButtonClickAction, ExportData, insertFavPage, deleteFavPage, getCurrentFavPage
}